import authentikConfig, {
  getAuthEndpoints,
  isAuthentikConfigured,
} from '../authentikConfig';

const STORAGE_VERIFIER = 'oidc_pkce_verifier';
const STORAGE_STATE = 'oidc_state';

function base64UrlEncode(buffer) {
  const bytes = new Uint8Array(buffer);
  let str = '';
  for (const b of bytes) str += String.fromCharCode(b);
  return btoa(str).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

function randomString(length = 64) {
  const arr = new Uint8Array(length);
  crypto.getRandomValues(arr);
  return base64UrlEncode(arr).slice(0, length);
}

async function sha256(text) {
  const data = new TextEncoder().encode(text);
  return await crypto.subtle.digest('SHA-256', data);
}

export async function startLogin() {
  if (!isAuthentikConfigured()) {
    throw new Error('Authentik OIDC 尚未設定，請先填寫 authentikConfig.js');
  }
  const verifier = randomString(64);
  const challenge = base64UrlEncode(await sha256(verifier));
  const state = randomString(32);

  sessionStorage.setItem(STORAGE_VERIFIER, verifier);
  sessionStorage.setItem(STORAGE_STATE, state);

  const { authorization } = getAuthEndpoints();
  const params = new URLSearchParams({
    response_type: 'code',
    client_id: authentikConfig.clientId,
    redirect_uri: authentikConfig.redirectUri,
    scope: authentikConfig.scope,
    state,
    code_challenge: challenge,
    code_challenge_method: 'S256',
  });
  window.location.href = `${authorization}?${params.toString()}`;
}

export async function exchangeCodeForToken(code, state) {
  const savedState = sessionStorage.getItem(STORAGE_STATE);
  const verifier = sessionStorage.getItem(STORAGE_VERIFIER);
  if (!savedState || !verifier) throw new Error('OIDC session 資料遺失，請重新登入');
  if (state !== savedState) throw new Error('OIDC state 不一致，請重新登入');

  const { token } = getAuthEndpoints();
  const body = new URLSearchParams({
    grant_type: 'authorization_code',
    code,
    redirect_uri: authentikConfig.redirectUri,
    client_id: authentikConfig.clientId,
    code_verifier: verifier,
  });
  const res = await fetch(token, {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body,
  });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(`取得 access token 失敗：${res.status} ${text}`);
  }
  sessionStorage.removeItem(STORAGE_VERIFIER);
  sessionStorage.removeItem(STORAGE_STATE);
  return res.json();
}

export function logoutRedirect() {
  try {
    const { endSession } = getAuthEndpoints();
    if (isAuthentikConfigured() && endSession) {
      const params = new URLSearchParams({
        post_logout_redirect_uri: window.location.origin,
      });
      window.location.href = `${endSession}?${params.toString()}`;
      return;
    }
  } catch {
    /* ignore */
  }
  window.location.href = '/';
}
